// this module just exports a globally available globals object

// The topmost React Context component (BrowserContext or ServerContext) is
// repsonsible for updating this object with actual globals data

// other modules can require this object, but they shouldn't access its
// properties in their module definition, only inside runtime methods (e.g.
// initialize, templateContext, onRender, etc)

module.exports = {}
